import React, { useState, useContext, useEffect } from "react";
import { SelectComponent } from "components/select/select";
import { environment } from "@environment";
import { createDateOptions } from "core/lib/list-methods";
import { getAnalyticTags } from "core/lib/analytics-methods";
import context from "core/tv-guide.context";
import { AppContext } from "core/providers/tv-guide.context";
import { UrlBuilder } from "@lib-shared/lib";
import prefixUrl from "core/lib/prefix-url";
import { SelectOption } from "core/types";

type DownloadContentProps = {
  popupInfo: Array<any>
}

const DownloadContent = (props: DownloadContentProps) => {
  const appContext = useContext(AppContext);
  const store = appContext.store;

  const [dateRange, setDateRange] = useState(1);
  const [dateList, setDateList] = useState<Array<SelectOption>>([]);
  const [compact, setCompact] = useState(false);

  const dictionary = context.dictionary;

  const defaultImageUrl = prefixUrl("media/krke21ob/logo.svg");

  const channelTags = props.popupInfo.map((channelNumber: number) => {
    let tag = store.schedule[channelNumber]?.tag;

    tag = tag ?? store.channels[channelNumber].tag

    return tag;
  });

  useEffect(() => {
    if (!store.hasScheduleData) {
      return;
    }
    // Dates
    const dtList = createDateOptions();
    setDateList(dtList ?? []);
  }, [store.hasScheduleData]);

  const setSelectCallback = (item: any, selectType: any) => {
    if (selectType === "date" && dateRange !== item) {
      setDateRange(item);
    }
  }

  const getDownloadUrl = (tagList: any, dateRange: any) => {
    const url = new UrlBuilder(environment.apiUrlBase)
      .appendPath("/WebMethods/TvGuidePdf.ashx")
      .appendParam("culture", context.culture)
      .appendParam("channels", tagList)
      .appendParam("duration", dateRange)
      .appendParam("compact", compact ? "1" : "0")
      .appendParam("country", context.guideCountryCode, true)
      .appendParam("unit", context.guideUnit, true)

    return url.toString();
  }

  if (!props.popupInfo.length) {
    return (
      <div className="download-content empty-state">
        <div className="popup-header"></div>
        <div className="popup-body">
          <p className="header-icon-download">
            <span className="icon-downloads"></span>
          </p>
          <h3>{dictionary.noFavouritesToDownload}</h3>
          <p>
            {dictionary.selectTheStar}
          </p>
        </div>
      </div>
    );
  }

  const downloadUrl = getDownloadUrl(channelTags.join(","), dateRange);

  const download = () => window.open(downloadUrl, "_blank");

  const analytics = getAnalyticTags({
    component_name: "favourite_remind_me",
    component_type: "show_modal",
    action_type: dictionary.downloadPdf,
    days_selected: dateRange,
    view_selected: compact ? "compact" : "normal",
    channels_selected: channelTags.join(","),
    target_page_url: downloadUrl
  });

  return (
    <div className="download-content">
      <div className="popup-header">
        <h3>{dictionary.pdfDownload}</h3>
        <p>
          {dictionary.selectHowManyDays}
        </p>
      </div>
      <div className="popup-body">
        <SelectComponent
          selectType="date"
          label={dictionary.selectDays}
          list={dateList}
          callback={(item: SelectOption) => {
            setSelectCallback(item.value, "date");
          }} />

        <div className="input-holder">
          <label
            htmlFor="normal"
            className="compact-checkbox"
            onClick={() => {
              setCompact(false);
            }}
          >
            {dictionary.normalView}
            <input
              type="radio"
              id="normal"
              name="compact"
              value="false"
              defaultChecked />
            <span className="custom-checkbox icon-tick"></span>
            <span className="custom-checkbox icon-list text-dark"></span>
          </label>
          <label
            htmlFor="compact"
            className="compact-checkbox"
            onClick={() => {
              setCompact(true);
            }}
          >
            {dictionary.compressedView}
            <input
              type="radio"
              id="compact"
              name="compact"
              value="true" />
            <span className="custom-checkbox icon-tick"></span>
            <span className="custom-checkbox icon-list text-dark"></span>
          </label>
        </div>
        <div className="channel-holder">
          {props.popupInfo.map((channelNumber: number) => {
            const channel = store.channels[channelNumber];
            return (
              <div className="download-channel" key={channelNumber}>
                <img
                  alt="favourited-channel"
                  src={`${channel ? channel.logo : defaultImageUrl}`}
                />
                <span className="icon-star_full star"></span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="popup-footer">
        <button
          type="button"
          className="button programme-btn"
          {...analytics}
          onClick={download}>
          <span className="text">{dictionary.downloadPdf}</span>
        </button>
      </div>
    </div>
  );
}

export default DownloadContent;